import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import * as dat from 'lil-gui'

/**
 * Base
 */

/**
 * fontLoader内で生成したMeshはスコープ外となりtickで参照できないので、
 * fontloader外で空の配列を作成し、この中にそれぞれのMeshをpushすることで、tick内でMeshが参照できるようになる。
 */
const objects = []

// Debug
const gui = new dat.GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const matcapTexture = textureLoader.load('textures/matcaps/9.png')

/**
 * Fonts
 */
const fontLoader = new FontLoader()

fontLoader.load(
    '/fonts/optimer_regular.typeface.json',
    (font) =>
    {
        // Material
        const material = new THREE.MeshMatcapMaterial({ matcap: matcapTexture })

        // Text
        const textGeometry = new TextGeometry(
            'Hello Three.js',
            {
                font: font,
                size: 0.5,
                height: 0.2,
                curveSegments: 12,
                bevelEnabled: true,
                bevelThickness: 0.03,
                bevelSize: 0.02,
                bevelOffset: 0,
                bevelSegments: 5
            }
        )
        textGeometry.center()

        const text = new THREE.Mesh(textGeometry, material)
        scene.add(text)

        const boxGeometry = new THREE.BoxGeometry(1, 1, 1, 2, 2, 2)
        const icosahedronGeometry = new THREE.IcosahedronGeometry(1, 0)
        const donutGeometry = new THREE.TorusGeometry(0.3, 0.2, 32, 64)


        for(let i = 0; i < 50; i++) {
            const box = new THREE.Mesh(boxGeometry, material)
            const icosahedron = new THREE.Mesh(icosahedronGeometry, material)
            const donut = new THREE.Mesh(donutGeometry, material)

            box.position.x = (Math.random() - 0.5) * 10
            box.position.y = (Math.random() - 0.5) * 10
            box.position.z = (Math.random() - 0.5) * 10
            box.rotation.x = Math.random() * Math.PI
            box.rotation.y = Math.random() * Math.PI

            icosahedron.position.x = (Math.random() - 0.5) * 10
            icosahedron.position.y = (Math.random() - 0.5) * 10
            icosahedron.position.z = (Math.random() - 0.5) * 10
            icosahedron.rotation.x = Math.random() * Math.PI
            icosahedron.rotation.y = Math.random() * Math.PI

            donut.position.x = (Math.random() - 0.5) * 10
            donut.position.y = (Math.random() - 0.5) * 10
            donut.position.z = (Math.random() - 0.5) * 10
            donut.rotation.x = Math.random() * Math.PI
            donut.rotation.y = Math.random() * Math.PI

            const scale = Math.random()

            box.scale.set(scale, scale, scale)
            icosahedron.scale.set(scale, scale, scale)
            donut.scale.set(scale, scale, scale)

            scene.add(box)
            scene.add(icosahedron)
            scene.add(donut)

            objects.push(box)
            objects.push(icosahedron)
            objects.push(donut)
        }
    }
)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 1
camera.position.y = 1
camera.position.z = 2
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setClearColor(new THREE.Color(0xffffff))
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const tick = () =>
{
    for(let i = 0; i < objects.length; i++) {
        /**
         * Math.random()は異なる値(乱数)を生成し続けるだけでelapsedTimeのように値が徐々に増加していくわけではないので、
         * Math.random()を使ってランダムなアニメーションを実現したい場合は=ではなく+=で値を加算していく必要がある。
         * 反対に、elapsedTimeは値が徐々に増加していくので、+=を使わずとも=でアニメーションを実現できる。
         */
        objects[i].rotation.x += Math.random() * 0.05;
        objects[i].rotation.y += Math.random() * 0.05;
    }

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()